<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="documenttype_title"
            class="form-control-label">{{$t('views.documenttype.form.title')}}:</label>
          <input
            id="title"
            v-model="item.title"
            :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
            type="text"
            placeholder="">
          <div
            v-if="isInvalid('title')"
            class="invalid-feedback">{{ violations.title }}</div>
        </div>
      </b-col>
      <b-col cols="6">
        <label>{{$t('views.documenttype.form.accessType')}}: </label>
        <div>
          <b-form-radio-group buttons button-variant="outline-primary" id="requirePromotion" v-model="item.accessType">
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('views.documenttype.form.accessTypeOptions.all')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.documenttype.form.accessTypeOptions.byRoles')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="2">{{$t('views.documenttype.form.accessTypeOptions.self')}}</b-form-radio>
          </b-form-radio-group>
        </div>
      </b-col>
      <b-col cols="6" v-if="item.accessType === 1">
        <div class="form-group">
          <label
            for="documenttype_caseTypesAllowed"
            class="form-control-label">{{$t('views.documenttype.form.rolesToViewAllowed')}}:</label>
          <b-form-group>
            <b-form-checkbox-group
              v-model="item.rolesToViewAllowed"
              :options="clientTypeOptions"
              name="documenttype_rolesToViewAllowed"
            ></b-form-checkbox-group>
          </b-form-group>
          <div
            v-if="isInvalid('rolesToViewAllowed')"
            class="invalid-feedback">{{ violations.rolesToViewAllowed }}</div>
        </div>
      </b-col>
    </b-row>
    <button
      type="submit"
      class="btn btn-success">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'

export default {
  created () {
    this.getClientTypes()
  },
  data () {
    return {
      clientTypeOptions: []
    }
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    async getClientTypes () {
      let params = { pagination: false }
      const response = await new ApiService('client_types', params).getResults()
      this.clientTypeOptions = response.items.map(entry => {
        return {
          value: getId(entry['@id']),
          text: entry.title
        }
      })
    }
  }
}
</script>
